import { render, staticRenderFns } from "./Log-Sections.vue?vue&type=template&id=226ca7b4&scoped=true"
import script from "./Log-Sections.vue?vue&type=script&lang=js"
export * from "./Log-Sections.vue?vue&type=script&lang=js"
import style0 from "./Log-Sections.vue?vue&type=style&index=0&id=226ca7b4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226ca7b4",
  null
  
)

export default component.exports